import { render, staticRenderFns } from "./RegisterPartner.vue?vue&type=template&id=5f3914ef&scoped=true"
import script from "./RegisterPartner.vue?vue&type=script&lang=js"
export * from "./RegisterPartner.vue?vue&type=script&lang=js"
import style0 from "./RegisterPartner.vue?vue&type=style&index=0&id=5f3914ef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f3914ef",
  null
  
)

export default component.exports